var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-products-permissions"},[_c('units'),_c('reservationsTeams',{attrs:{"teams":_vm.teamsData}}),_c('reservationsUsers',{attrs:{"users":_vm.usersData}}),_c('ui-personalize-message-modal')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }